export const expandablePrivatConfig = {
    aksjer: {
      header: 'Aksjer',
      subheaderKey: 'foretaksnavn',
      fields: [
        { title: 'Organisasjonsnummer', key: 'organisasjonsnummer' },
        { title: 'Foretaksnavn', key: 'foretaksnavn' },
        { title: 'Aksjeklasse', key: 'aksjeklasse' },
        { title: 'Antall aksjer eierskap', key: 'antallAksjerEierskap' },
        { title: 'Totalt antall aksjer selskap', key: 'totaltAntallAksjerSelskap' },
        { title: 'Andel eierskap brøk', key: 'andelEierskapBroek' },
      ],
    },
    betalingsanmerkninger: {
      header: 'Betalingsanmerkninger',
      subheaderKey: 'kreditor',
      fields: [
        { title: 'Kreditor', key: 'kreditor' },
        { title: 'Saksnummer', key: 'saksnummer' },
        { title: 'Registreringsdato', key: 'registreringsdato' },
        { title: 'Oppgjørsstatus', key: 'oppgjorsStatus' },
        { title: 'Oppgjørsdato', key: 'oppgjorsDato' },
        { title: 'Inkassobyrå', key: 'inkassobyraa' },
        { title: 'Type kode', key: 'typeKode' },
        { title: 'Type beskrivelse', key: 'typeBeskrivelse' },
        { title: 'Sakshendelsetype', key: 'sakshendelsetype' },
        { title: 'Beløp', key: 'belop' },
      ],
    },
    ligninger: {
      header: 'Ligninger',
      subheaderKey: 'ligningsaar',
      fields: [
        { title: 'Ligningsår', key: 'ligningsaar' },
        { title: 'Skatteklasse', key: 'skatteklasse' },
        { title: 'Netto inntekt', key: 'nettoInntekt' },
        { title: 'Netto formue', key: 'nettoFormue' },
        { title: 'Skatt', key: 'skatt' },
      ],
    },
    roller: {
      header: 'Roller',
      subheaderKey: 'foretaksnavn',
      fields: [
        { title: 'Orgnummer', key: 'organisasjonsnummer' },
        { title: 'Foretaksnavn', key: 'foretaksnavn' },
        { title: 'Daglig leder', key: 'dagligLeder' },
        { title: 'Innehaver', key: 'innehaver' },
        { title: 'Styreleder', key: 'styreleder' },
        { title: 'Nestleder', key: 'nestleder' },
        { title: 'Styremedlem', key: 'styremedlem'},
      ],
    },
  };

export const expandableNæringConfig = {
    aksjer: {
      header: 'Aksjer',
      subheaderKey: 'foretaksnavn',
      fields: [
        { title: 'Organisasjonsnummer', key: 'organisasjonsnummer' },
        { title: 'Foretaksnavn', key: 'foretaksnavn' },
        { title: 'Aksjeklasse', key: 'aksjeklasse' },
        { title: 'Antall aksjer eierskap', key: 'antallAksjerEierskap' },
        { title: 'Totalt antall aksjer selskap', key: 'totaltAntallAksjerSelskap' },
        { title: 'Andel eierskap brøk', key: 'andelEierskapBroek' },
      ],
    },
    aksjonaerer: {
      header: 'Aksjonærer',
      subheaderKey: 'navn',
      fields: [
        { title: 'Organisasjonsnummer', key: 'organisasjonsnummer' },
        { title: 'Fødselsdato', key: 'fodselsdato' },
        { title: 'Navn', key: 'navn' },
        { title: 'Eierskapstype', key: 'eierskapstype' },
        { title: 'Aksjeklasse', key: 'aksjeklasse' },
        { title: 'Antall aksjer eierskap', key: 'antallAksjerEierskap' },
        { title: 'Totalt antall aksjer selskap', key: 'totaltAntallAksjerSelskap' },
        { title: 'Andel eierskap brøk', key: 'andelEierskapBroek' },
      ],
    },
    betalingsanmerkninger: {
      header: 'Betalingsanmerkninger',
      subheaderKey: 'kreditor',
      fields: [
        { title: 'Kreditor', key: 'kreditor' },
        { title: 'Saksnummer', key: 'saksnummer' },
        { title: 'Registreringsdato', key: 'registreringsdato' },
        { title: 'Oppgjørsstatus', key: 'oppgjorsStatus' },
        { title: 'Oppgjørsdato', key: 'oppgjorsDato' },
        { title: 'Inkassobyrå', key: 'inkassobyraa' },
        { title: 'Type kode', key: 'typeKode' },
        { title: 'Type beskrivelse', key: 'typeBeskrivelse' },
        { title: 'Sakshendelse type', key: 'sakshendelsetype' },
        { title: 'Beløp', key: 'belop' },
      ],
    },
    regnskap: {
      header: 'Regnskap',
      subheaderKey: 'regnskapsaar',
      groupSizes: [2, 6],
      groupHeaders: ['Regnskapsperiode', 'Generell informasjon', 'Resultatregnskap'],
      fields: [
        { title: 'Fra dato', key: 'fraDato' },
        { title: 'Til dato', key: 'tilDato' },
        { title: 'Morselskap', key: 'morselskap' },
        { title: 'Avviklingsregnskap', key: 'avviklingsRegnskap' },
        { title: 'Oppstillingsplan', key: 'oppstillingsPlan' },
        { title: 'Ikke-revidert årsregnskap', key: 'ikkeRevidertAarsregnskap' },
        { title: 'Fravalg revisjon', key: 'fravalgRevisjon' },
        { title: 'Småforetak', key: 'smaaForetak' },
        { title: 'Driftsinntekter', key: 'driftsinntekter' },
        { title: 'Driftskostnad', key: 'driftskostnad' },
        { title: 'Driftsresultat', key: 'driftsresultat' },
        { title: 'Finansinntekter', key: 'finansinntekter' },
        { title: 'Finanskostnad', key: 'finanskostnad' },
        { title: 'Netto finans', key: 'nettoFinans' },
        { title: 'Ordinært resultat før skattekostnad', key: 'ordinaertResultatFoerSkattekostnad' },
        { title: 'Årsresultat', key: 'aarsResultat' },
        { title: 'Total resultat', key: 'totalResultat' },
        { title: 'Anleggsmidler', key: 'anleggsmidler' },
        { title: 'Omløpsmidler', key: 'omloepsmidler' },
        { title: 'Sum Eiendeler', key: 'sumEiendeler' },
        { title: 'Langsiktig gjeld', key: 'langsiktigGjeld' },
        { title: 'Kortsiktig gjeld', key: 'kortsiktigGjeld' },
        { title: 'Sum gjeld', key: 'sumGjeld' },
        { title: 'Innskutt egenkaptial', key: 'innskuttEgenkaptial' },
        { title: 'Opptjent egenkapital', key: 'opptjentEgenkapital' },
        { title: 'Sum egenkapital gjeld', key: 'sumEgenkapitalGjeld' },
        { title: 'Sum egenkapital', key: 'sumEgenkapital' },
      ],
    },
    roller: {
      header: 'Roller',
      subheaderKey: 'rolleType',
      fields: [
        { title: 'Rolletype', key: 'rolleType' },
        { title: 'Navn', key: 'navn' },
        { title: 'Fødselsår', key: 'foedselsAar' },
      ],
    },
  };

export const privatConfig = [
    {
      header: 'Person',
      fields: [
        { title: 'Fornavn', key: 'fornavn' },
        { title: 'Etternavn', key: 'etternavn' },
        { title: 'Fullt navn', key: 'navn' },
        { title: 'Fødselsdato', key: 'foedselsdato' },
        { title: 'Status', key: 'statusPrivat' },
        { title: 'Innehaver Enk', key: 'innehaverEnk' },
      ],
    },
    {
      header: 'Bostedsadresse',
      fields: [
        { title: 'Adresse', key: 'bostedsadresseAdresse' },
        { title: 'Poststed', key: 'bostedsadressePoststed' },
        { title: 'Postnummer', key: 'bostedsadressePostnummer' },
        { title: 'Kommune', key: 'bostedsadresseKommune' },
        { title: 'Kommunenummer', key: 'bostedsadresseKommunenummer' },
      ],
    },
    {
      header: 'Postadresse',
      fields: [
        { title: 'Adresse', key: 'postadresseAdresse' },
        { title: 'Poststed', key: 'postadressePoststed' },
        { title: 'Postnummer', key: 'postadressePostnummer' },
        { title: 'Kommune', key: 'postadresseKommune' },
        { title: 'Kommunenummer', key: 'postadresseKommunenummer' },
      ],
    },
    {
      header: 'Postboks',
      fields: [
        { title: 'Adresse', key: 'postboksadresseAdresse' },
        { title: 'Poststed', key: 'postboksadressePoststed' },
        { title: 'Postnummer', key: 'postboksadressePostnummer' },
      ],
    },
    {
      header: 'Pant',
      fields: [
        { title: 'Utleggspant antall', key: 'utleggspantAntall' },
        { title: 'Utleggspant beløp', key: 'utleggspantBelop' },
      ],
    },
    {
      header: 'Tvangsforretning',
      fields: [
        { title: 'Eiendom antall', key: 'tvangsforretningEiendomAntall' },
        { title: 'Eiendom beløp', key: 'tvangsforretningEiendomBelop' },
        { title: 'Eiendom tvangssalg beløp', key: 'tvangssalgEiendomBesluttetAntall' },
      ],
    },
    {
      header: 'Arrest',
      fields: [
        { title: 'Antall', key: 'arrestAntall' },
        { title: 'Beløp', key: 'arrestBelop' },
      ],
    },
    {
      header: 'Gjeldsordning',
      fields: [
        { title: 'Åpning antall', key: 'gjeldsordningAapningAntall' },
        { title: 'Frivillig antall', key: 'gjeldsordningFrivilligAntall' },
        { title: 'Tvungen antall', key: 'gjeldsordningTvungenAntall' },
      ],
    },
  ];


export const næringConfig = [
        {
        header: 'Foretak',
        fields: [
            { title: 'Foretaksnavn', key: 'foretaksnavn' },
            { title: 'Organisasjonsnummer', key: 'organisasjonsnummer' },
            { title: 'Organisasjonsform', key: 'organisasjonsform' },
            { title: 'Stiftelsesdato', key: 'stiftelsesdato' },
            { title: 'Antall ansatte', key: 'antallAnsatte' },
        ],
        },
        {
        header: 'Næringskode',
        fields: [
            { title: 'Næringskode', key: 'naeringskode' },
            { title: 'Næringskode tekst', key: 'naeringskodeTekst' },
        ],
        },
        {
        header: 'Forretningsadresse',
        fields: [
            { title: 'Adresse', key: 'forretningsadresseAdresse' },
            { title: 'Poststed', key: 'forretningsadressePoststed' },
            { title: 'Postnummer', key: 'forretningsadressePostnummer' },
            { title: 'Kommune', key: 'forretningsadresseKommune' },
            { title: 'Kommunenummer', key: 'forretningsadresseKommunenummer' },
            { title: 'Land', key: 'forretningsadresseLand' },
            { title: 'Landkode', key: 'forretningsadresseLandkode' },
        ],
        },
        {
        header: 'Postadresse',
        fields: [
            { title: 'Adresse', key: 'postadresseAdresse' },
            { title: 'Poststed', key: 'postadressePoststed' },
            { title: 'Postnummer', key: 'postadressePostnummer' },
            { title: 'Kommune', key: 'postadresseKommune' },
            { title: 'Kommunenummer', key: 'postadresseKommunenummer' },
            { title: 'Land', key: 'postadresseLand' },
            { title: 'Landkode', key: 'postadresseLandkode' },
        ],
        },
        {
        header: 'Status',
        fields: [
            { title: 'Status', key: 'statusNæring' },
            { title: 'Statusdato', key: 'statusdato' },
            { title: 'Kredittsperre', key: 'kredittSperre' },
        ],
        },
        {
        header: 'Pant',
        fields: [
            { title: 'Utleggspant antall', key: 'utleggspantAntall' },
            { title: 'Utleggspant beløp', key: 'utleggspantBelop' },
            { title: 'Intet til utlegg antall', key: 'intetTilUtleggAntall' },
        ],
        },
        {
        header: 'Tvangsforretning',
        fields: [
            { title: 'Eiendom antall', key: 'tvangsforretningEiendomAntall' },
            { title: 'Eiendom beløp', key: 'tvangsforretningEiendomBelop' },
            { title: 'Eiendom tvangssalg antall', key: 'tvangssalgEiendomBesluttetAntall' },
        ],
        },
        {
        header: 'Arrest',
        fields: [
            { title: 'Antall', key: 'arrestAntall' },
            { title: 'Beløp', key: 'arrestBelop' },
        ],
        },
    ];


  export const privatConfigV4 = {
    shares: {
      header: 'Aksjer',
      subheaderKey: 'organisationName',
      fields: [
        { title: 'Org.nr.',        key: 'organisationId' },
        { title: 'Navn',           key: 'organisationName' },
        { title: 'Klasse',         key: 'shareClass' },
        { title: 'Eide aksjer',    key: 'numberOfOwnedShares' },
        { title: 'Totale aksjer',  key: 'totalNumberOfCompanyShares' },
        { title: 'Eierandel',      key: 'shareOfOwnership' },
      ],
    },
    shareholders: {
      header: 'Aksjonærer',
      subheaderKey: 'shareClass',
      fields: [
        { title: 'Navn',           key: 'owner.name' },
        { title: 'Eiertype',       key: 'owner.type' },
        { title: 'Klasse',         key: 'shareClass' },
        { title: 'Eide aksjer',    key: 'numberOfOwnedShares' },
        { title: 'Totale aksjer',  key: 'totalNumberOfCompanyShares' },
        { title: 'Eierandel',      key: 'shareOfOwnership' },
      ],
    },
    paymentRemarks: {
      header: 'Betalingsanmerkninger',
      subheaderKey: 'creditor',
      fields: [
        { title: 'Kreditor',         key: 'creditor' },
        { title: 'Saknr.',           key: 'caseNumber' },
        { title: 'Reg.dato',         key: 'registrationDate' },
        { title: 'Status',           key: 'settlementStatus' },
        { title: 'Oppgj.dato',       key: 'settlementDate' },
        { title: 'Byrå',             key: 'collectionAgency' },
        { title: 'Kode',             key: 'typeCode' },
        { title: 'Beskr.',           key: 'typeDescription' },
        { title: 'Hend.type',        key: 'caseEventType' },
        { title: 'Beløp',            key: 'amount' },
      ],
    },
    salaryDeductions: {
        header: 'Utleggstrekk',
        subheaderKey: 'caseNumber',
        fields: [
          { title: 'Saknr.',           key: 'caseNumber' },
          { title: 'Mnd.beløp',        key: 'monthlyAmount' },
          { title: 'Start',            key: 'startDate' },
          { title: 'Slutt',            key: 'endDate' },
          { title: 'Avh.forr.',        key: 'hearingHeld' },
          { title: 'Søker org.nr.',    key: 'claimant.organisationId' },
          { title: 'Søker navn',       key: 'claimant.name' },
          { title: 'Fullm. org.nr.',   key: 'processRepresentativeAgent.organisationId' },
          { title: 'Fullm. navn',      key: 'processRepresentativeAgent.name' },
          { title: 'Namsm. org.nr.',   key: 'enforcementAuthority.organisationId' },
          { title: 'Namsm. navn',      key: 'enforcementAuthority.name' },
        ],
    },
    noAssetsForSeizure: {
      header: 'Intet Til Utlegg',
      subheaderKey: 'caseNumber',
      fields: [
        { title: 'Sak.nr.',          key: 'caseNumber' },
        { title: 'Avh.forr.',        key: 'hearingHeld' },
        { title: 'Søker org.nr.',    key: 'claimant.organisationId' },
        { title: 'Søker navn',       key: 'claimant.name' },
        { title: 'Fullm. org.nr.',   key: 'processRepresentativeAgent.organisationId' },
        { title: 'Fullm. navn',      key: 'processRepresentativeAgent.name' },
        { title: 'Namsm. org.nr.',   key: 'enforcementAuthority.organisationId' },
        { title: 'Namsm. navn',      key: 'enforcementAuthority.name' },
      ],
    },
    movableAssets: {
      header: 'Pant',
      subheaderKey: 'documentNumber',
      fields: [
        { title: 'Dok.nr.',           key: 'documentNumber' },
        { title: 'Fullbyrd.',         key: 'enforced' },
        { title: 'Utl.tidsp',         key: 'expiryDateLegalProtection' },
        { title: 'Eiendel',           key: 'asset.type' },
        { title: 'Panthever Navn',    key: 'roles[0].roleHolder.name' },
        { title: 'Panthever Org.ID',  key: 'roles[0].roleHolder.organisationId' },
        { title: 'Pantsetter Navn',   key: 'roles[1].roleHolder.name' },
        { title: 'Pantsetter Org.ID', key: 'roles[1].roleHolder.organisationId' },
      ],
    },
    propertyForeclosures: {
      header: 'Tvangsfullbyrdelse av eiendom',
      subheaderKey: 'id',
      fields: [
        { title: 'ID',           key: 'id' },
        { title: 'Grunnlag',     key: 'legalFoundation' },
        { title: 'Ansvar',       key: 'directResponsibility' },
        { title: 'Oppdatert',    key: 'updatedDate' },
        { title: 'Reg.dato',     key: 'registeredDate' },
        { title: 'Fl.eiend.',    key: 'registeredOnMultipleProperties' },
        { title: 'Saksøkte',     key: 'multipleDefendants' },
        { title: 'Beløp',        key: 'amount.amount' },
        { title: 'Kravst.',      key: 'claimant.name' },
        { title: 'Fullm.',       key: 'processRepresentativeAgents[0].name' },
      ],
    },
    propertyEnforcedActionRemarks: {
      header: 'Merknader om eiendomstvangsforretning',
      subheaderKey: 'id',
      fields: [
        { title: 'ID',           key: 'id' },
        { title: 'Reg.dato',     key: 'registeredDate' },
        { title: 'Fl.eiend.',    key: 'registeredOnMultipleProperties' },
        { title: 'Ansvar',       key: 'directResponsibility' },
        { title: 'Saksnr.',      key: 'caseNumber' },
        { title: 'Grunnlag',     key: 'legalFoundation' },
        { title: 'Fritekst',     key: 'freeText' },
        { title: 'Tingrett',     key: 'districtCourt' },
        { title: 'Bobestyrer',   key: 'estateManager' },
      ],
    },
    incomeStatements: {
      header: 'Ligninger',
      subheaderKey: 'taxYear',
      fields: [
        { title: 'Ligningsår', key: 'taxYear' },
        { title: 'Skatteklasse', key: 'taxClass' },
        { title: 'Netto inntekt', key: 'netIncome' },
        { title: 'Netto formue', key: 'netWealth' },
        { title: 'Skatt', key: 'tax' },
      ],
    },
    roles: {
      header: 'Roller',
      subheaderKey: 'description',
      fields: [
        { title: 'Organisasjonsnr', key: 'organisationId' },
        { title: 'Foretaksnavn', key: 'organisationName' },
        { title: 'Beskrivelse', key: 'description' },
        { title: 'Daglig leder', key: 'dagligLeder' },
        { title: 'Styreleder', key: 'styreleder' },
        { title: 'Styremedlem', key: 'styremedlem'},
        { title :'Nestleder', key: 'nestleder'},
      ],
    },
    properties: {
      header: 'Eiendom',
      subheaderKey: 'propertyType',
      fields: [
        { title: 'Heftelser',          key: 'liens.length' },
        { title: 'Type',               key: 'info.propertyType' },
        { title: 'Formål',             key: 'info.type' },
        { title: 'Hjemmel',            key: 'info.ownershipRights' },
        { title: 'Eierandel',          key: 'info.shareOfOwnership' },
        { title: 'Reg.enh. ID',        key: 'info.registerUnitId' },
        { title: 'Adresse',            key: 'info.address' },
        { title: 'Postnr.',            key: 'info.zipCode' },
        { title: 'Poststed',           key: 'info.postalAddress' },
        { title: 'Salg.dato',          key: 'valuation.previousSaleDate' },
        { title: 'Salg.pris',          key: 'valuation.previousSalePrice' },
        { title: 'Est.pris',           key: 'valuation.estimatedPrice' },
        { title: 'Brukstype',          key: 'info.propertyType' },
        { title: 'Boligtype',          key: 'info.type' },
        { title: 'Kom.nr.',            key: 'info.municipalityNumber' },
        { title: 'Gnr.',               key: 'info.cadastralUnitNumber' },
        { title: 'Bnr.',               key: 'info.unitNumber' },
      ],
    },
    propertiesLiens: {
      header: 'Heftelser (Eiendom)',
      subheaderKey: 'id',
      fields: [
        { title: 'ID',               key: 'id' },
        { title: 'Type',             key: 'type' },
        { title: 'Jur.grunnlag',     key: 'legalFoundation' },
        { title: 'Direkte ansvar',   key: 'directResponsibility' },
        { title: 'Flere eiendommer', key: 'registeredOnMultipleProperties' },
        { title: 'Tot.pant',         key: 'amounts[0].amount' },
        { title: 'Est. tot.pant',    key: 'amounts[0].estimatedRemainingAmount' },
        { title: 'Valuta',           key: 'amounts[0].currency' },
        { title: 'Oppd.dato',        key: 'updatedDate' },
        { title: 'Reg.dato',         key: 'registeredDate' },
        { title: 'Rett.haver type',  key: 'rightsHolders[0].name' },
        { title: 'Rett.haver navn',  key: 'rightsHolders[0].organisationId' },
        { title: 'Rett.haver orgid', key: 'rightsHolders[0].name' },
      ],
    },
    vehicles: {
      header: 'Kjøretøy',
      subheaderKey: 'registrationNumber',
      fields: [
        { title: 'Antall heftelser', key: 'liens.length' },
        { title: 'Reg.nr.',          key: 'info.registrationNumber' },
        { title: 'Type',             key: 'info.vehicleType' },
        { title: 'Merke',            key: 'info.brand' },
        { title: 'Modell',           key: 'info.model' },
        { title: 'Først.reg.',       key: 'info.firstRegistrationDate' },
        { title: 'Reg.stat.',        key: 'info.registrationStatus' },
        { title: 'Forh.pris',        key: 'valuation.estimatedDealerPrice' },
        { title: 'Priv.pris',        key: 'valuation.estimatedPrivateSalePrice' },
      ],
    },
    vehicleLiens: {
      header: 'Heftelser (Kjøretøy)',
      subheaderKey: 'id',
      fields: [
        { title: 'Dok.nr',               key: 'documentNumber' },
        { title: 'Type',                 key: 'type' },
        { title: 'Reg.tidspunkt',        key: 'entryTimestamp' },
        { title: 'Vedtakstidspunkt',     key: 'decisionTimestamp' },
        { title: 'Utløpsdato rettsvern', key: 'expiryDateLegalProtection' },
        { title: 'Beløp',                key: 'amounts[0].amount' },
        { title: 'valuta',               key: 'amounts[0].currency' },
        { title: 'Pantsetter type',      key: 'mortagor[0].type' },
        { title: 'Pantsetter orgid',     key: 'mortagor[0].organisationId' },
        { title: 'Pantsetter navn',      key: 'mortagor[0].name' },
        { title: 'Panthaver type',       key: 'lienHolder[0].type' },
        { title: 'Panthaver orgid',      key: 'lienHolder[0].organisationId' },
        { title: 'Panthaver navn',       key: 'lienHolder[0].name' },
      ],
    },
  };

  export const næringConfigV4 = {
    shares: {
      header: 'Aksjer',
      subheaderKey: 'organisationName',
      fields: [
        { title: 'Org.nr.',        key: 'organisationId' },
        { title: 'Navn',           key: 'organisationName' },
        { title: 'Klasse',         key: 'shareClass' },
        { title: 'Eide aksjer',    key: 'numberOfOwnedShares' },
        { title: 'Totale aksjer',  key: 'totalNumberOfCompanyShares' },
        { title: 'Eierandel',      key: 'shareOfOwnership' },
      ],
    },
    shareholders: {
      header: 'Aksjonærer',
      subheaderKey: 'shareClass',
      fields: [
        { title: 'Navn',           key: 'owner.name' },
        { title: 'Eiertype',       key: 'owner.type' },
        { title: 'Klasse',         key: 'shareClass' },
        { title: 'Eide aksjer',    key: 'numberOfOwnedShares' },
        { title: 'Totale aksjer',  key: 'totalNumberOfCompanyShares' },
        { title: 'Eierandel',      key: 'shareOfOwnership' },
      ],
    },
    paymentRemarks: {
      header: 'Betalingsanmerkninger',
      subheaderKey: 'creditor',
      fields: [
        { title: 'Kreditor',         key: 'creditor' },
        { title: 'Saknr.',           key: 'caseNumber' },
        { title: 'Reg.dato',         key: 'registrationDate' },
        { title: 'Status',           key: 'settlementStatus' },
        { title: 'Oppgj.dato',       key: 'settlementDate' },
        { title: 'Byrå',             key: 'collectionAgency' },
        { title: 'Kode',             key: 'typeCode' },
        { title: 'Beskr.',           key: 'typeDescription' },
        { title: 'Hend.type',        key: 'caseEventType' },
        { title: 'Beløp',            key: 'amount' },
      ],
    },
    movableAssets: {
      header: 'Pant',
      subheaderKey: 'documentNumber',
      fields: [
        { title: 'Dok.nr.',           key: 'documentNumber' },
        { title: 'Fullbyrd.',         key: 'enforced' },
        { title: 'Utl.tidsp',         key: 'expiryDateLegalProtection' },
        { title: 'Eiendel',           key: 'asset.type' },
        { title: 'Panthever Navn',    key: 'roles[0].roleHolder.name' },
        { title: 'Panthever Org.ID',  key: 'roles[0].roleHolder.organisationId' },
        { title: 'Pantsetter Navn',   key: 'roles[1].roleHolder.name' },
        { title: 'Pantsetter Org.ID', key: 'roles[1].roleHolder.organisationId' },
      ],
    },
    propertyForeclosures: {
      header: 'Tvangsfullbyrdelse av eiendom',
      subheaderKey: 'id',
      fields: [
        { title: 'ID',           key: 'id' },
        { title: 'Grunnlag',     key: 'legalFoundation' },
        { title: 'Ansvar',       key: 'directResponsibility' },
        { title: 'Oppdatert',    key: 'updatedDate' },
        { title: 'Reg.dato',     key: 'registeredDate' },
        { title: 'Fl.eiend.',    key: 'registeredOnMultipleProperties' },
        { title: 'Saksøkte',     key: 'multipleDefendants' },
        { title: 'Beløp',        key: 'amount.amount' },
        { title: 'Kravst.',      key: 'claimant.name' },
        { title: 'Fullm.',       key: 'processRepresentativeAgents[0].name' },
      ],
    },
    propertyEnforcedActionRemarks: {
      header: 'Merknader om eiendomstvangsforretning',
      subheaderKey: 'id',
      fields: [
        { title: 'ID',           key: 'id' },
        { title: 'Reg.dato',     key: 'registeredDate' },
        { title: 'Fl.eiend.',    key: 'registeredOnMultipleProperties' },
        { title: 'Ansvar',       key: 'directResponsibility' },
        { title: 'Saksnr.',      key: 'caseNumber' },
        { title: 'Grunnlag',     key: 'legalFoundation' },
        { title: 'Fritekst',     key: 'freeText' },
        { title: 'Tingrett',     key: 'districtCourt' },
        { title: 'Bobestyrer',   key: 'estateManager' },
      ],
    },
    financialStatements: {
      header: 'Regnskap',
      subheaderKey: 'financialYear',
      groupSizes: [2, 6],
      groupHeaders: ['Regnskapsperiode', 'Generell informasjon', 'Resultatregnskap'],
      fields: [
        { title: 'Fra dato', key: 'fromDate' },
        { title: 'Til dato', key: 'toDate' },
        { title: 'Morselskap', key: 'parentCompany' },
        { title: 'Avviklingsregnskap', key: 'liquidationAccounts' },
        { title: 'Oppstillingsplan', key: 'presentationPlan' },
        { title: 'Ikke-revidert årsregnskap', key: 'nonAuditedAnnualReport' },
        { title: 'Fravalg revisjon', key: 'optedOutOfAudit' },
        { title: 'Småforetak', key: 'smallEnterprise' },
        { title: 'Driftsinntekter', key: 'operatingIncome' },
        { title: 'Driftskostnad', key: 'operatingExpenses' },
        { title: 'Driftsresultat', key: 'operatingProfit' },
        { title: 'Finansinntekter', key: 'financialIncome' },
        { title: 'Finanskostnad', key: 'financialExpenses' },
        { title: 'Netto finans', key: 'netFinancials' },
        { title: 'Ordinært resultat før skattekostnad', key: 'ordinaryResultBeforeTax' },
        { title: 'Årsresultat', key: 'annualProfit' },
        { title: 'Total resultat', key: 'totalProfit' },
        { title: 'Anleggsmidler', key: 'fixedAssets' },
        { title: 'Omløpsmidler', key: 'currentAssets' },
        { title: 'Sum Eiendeler', key: 'totalAssets' },
        { title: 'Langsiktig gjeld', key: 'longTermLiabilities' },
        { title: 'Kortsiktig gjeld', key: 'shortTermLiabilities' },
        { title: 'Sum gjeld', key: 'totalLiabilities' },
        { title: 'Innskutt egenkaptial', key: 'paidInEquity' },
        { title: 'Opptjent egenkapital', key: 'earnedEquity' },
        { title: 'Sum egenkapital gjeld', key: 'totalEquityAndLiabilities' },
        { title: 'Sum egenkapital', key: 'totalEquity' },
      ],
    },
    roles: {
      header: 'Roller',
      subheaderKey: 'description',
      fields: [
        { title: 'Rolletype', key: 'description' },
        { title: 'Navn',      key: 'name' },
        { title: 'Type',      key: 'type' },
        { title: 'Org.ID',    key: 'organisationId' },
        { title: 'Fødselsdato', key: 'birthYear' },
      ],
    },
    properties: {
      header: 'Eiendom',
      subheaderKey: 'propertyType',
      fields: [
        { title: 'Heftelser',          key: 'liens.length' },
        { title: 'Type',               key: 'info.propertyType' },
        { title: 'Formål',             key: 'info.type' },
        { title: 'Hjemmel',            key: 'info.ownershipRights' },
        { title: 'Eierandel',          key: 'info.shareOfOwnership' },
        { title: 'Reg.enh. ID',        key: 'info.registerUnitId' },
        { title: 'Adresse',            key: 'info.address' },
        { title: 'Postnr.',            key: 'info.zipCode' },
        { title: 'Poststed',           key: 'info.postalAddress' },
        { title: 'Salg.dato',          key: 'valuation.previousSaleDate' },
        { title: 'Salg.pris',          key: 'valuation.previousSalePrice' },
        { title: 'Est.pris',           key: 'valuation.estimatedPrice' },
        { title: 'Brukstype',          key: 'info.propertyType' },
        { title: 'Boligtype',          key: 'info.type' },
        { title: 'Kom.nr.',            key: 'info.municipalityNumber' },
        { title: 'Gnr.',               key: 'info.cadastralUnitNumber' },
        { title: 'Bnr.',               key: 'info.unitNumber' },
      ],
    },
    propertiesLiens: {
      header: 'Heftelser (Eiendom)',
      subheaderKey: 'id',
      fields: [
        { title: 'ID',               key: 'id' },
        { title: 'Type',             key: 'type' },
        { title: 'Jur.grunnlag',     key: 'legalFoundation' },
        { title: 'Direkte ansvar',   key: 'directResponsibility' },
        { title: 'Flere eiendommer', key: 'registeredOnMultipleProperties' },
        { title: 'Tot.pant',         key: 'amounts[0].amount' },
        { title: 'Est. tot.pant',    key: 'amounts[0].estimatedRemainingAmount' },
        { title: 'Valuta',           key: 'amounts[0].currency' },
        { title: 'Oppd.dato',        key: 'updatedDate' },
        { title: 'Reg.dato',         key: 'registeredDate' },
        { title: 'Rett.haver type',  key: 'rightsHolders[0].name' },
        { title: 'Rett.haver navn',  key: 'rightsHolders[0].organisationId' },
        { title: 'Rett.haver orgid', key: 'rightsHolders[0].name' },
      ],
    },
    vehicles: {
      header: 'Kjøretøy',
      subheaderKey: 'registrationNumber',
      fields: [
        { title: 'Antall heftelser', key: 'liens.length' },
        { title: 'Reg.nr.',          key: 'info.registrationNumber' },
        { title: 'Type',             key: 'info.vehicleType' },
        { title: 'Merke',            key: 'info.brand' },
        { title: 'Modell',           key: 'info.model' },
        { title: 'Først.reg.',       key: 'info.firstRegistrationDate' },
        { title: 'Reg.stat.',        key: 'info.registrationStatus' },
        { title: 'Forh.pris',        key: 'valuation.estimatedDealerPrice' },
        { title: 'Priv.pris',        key: 'valuation.estimatedPrivateSalePrice' },
      ],
    },
    vehicleLiens: {
      header: 'Heftelser (Kjøretøy)',
      subheaderKey: 'id',
      fields: [
        { title: 'Dok.nr',               key: 'documentNumber' },
        { title: 'Type',                 key: 'type' },
        { title: 'Reg.tidspunkt',        key: 'entryTimestamp' },
        { title: 'Vedtakstidspunkt',     key: 'decisionTimestamp' },
        { title: 'Utløpsdato rettsvern', key: 'expiryDateLegalProtection' },
        { title: 'Beløp',                key: 'amounts[0].amount' },
        { title: 'valuta',               key: 'amounts[0].currency' },
        { title: 'Pantsetter type',      key: 'mortagor[0].type' },
        { title: 'Pantsetter orgid',     key: 'mortagor[0].organisationId' },
        { title: 'Pantsetter navn',      key: 'mortagor[0].name' },
        { title: 'Panthaver type',       key: 'lienHolder[0].type' },
        { title: 'Panthaver orgid',      key: 'lienHolder[0].organisationId' },
        { title: 'Panthaver navn',       key: 'lienHolder[0].name' },
      ],
    },
  };

  export const privatConfig2 = [
    {
      header: 'Grunndata',
      fields: [
          { title: 'Fødselsdato', key: 'birthDate' },
          { title: 'Fornavn', key: 'firstName' },
          { title: 'Etternavn', key: 'lastName' },
          { title: 'Status', key: 'status' },
          { title: 'Under vergemål', key: 'underGuardianship' },
      ],
    },
    {
    header: 'Bostedsadresse',
    fields: [
        { title: 'Adresse', key: 'residentialAddress.street' },
        { title: 'Poststed', key: 'residentialAddress.postalArea' },
        { title: 'Postnummer', key: 'residentialAddress.zipCode' },
        { title: 'Kommune', key: 'residentialAddress.municipalityName' },
        { title: 'Kommunenummer', key: 'residentialAddress.municipalityNumber' },
        { title: 'Postadresse', key: 'residentialAddress.postalAddress' },
        { title: 'Postboksadresse', key: 'residentialAddress.poBoxAddress' },
    ],
    },
    {
    header: 'Kredittvurdering',
    fields: [
        { title: 'Kredittvurdering karakter', key: 'scoreRating' },
        { title: 'Kredittvurdering score', key: 'normalisedScore' },
        { title: 'Kredittvurdering forklaring', key: 'scoreRatingExplanation' },
        { title: 'Råscore', key: 'rawScore' },
        { title: 'Sannsynlighet for mislighold', key: 'probabilityOfDefault' },
        { title: 'Forslag til kredittgrensen(NOK)', key: 'creditLimit' },
        { title: 'Betalingsanmerkninger antall', key: 'summary.paymentRemarksCount' },
        { title: 'Betalingsanmerkninger beløp', key: 'summary.paymentRemarksAmount' },
        { title: 'Gjeldsordning åpning antall', key: 'summary.debtRestructuringOpenedCount' },
        { title: 'Gjeldsordning frivillig antall', key: 'summary.debtRestructuringVoluntaryCount' },
        { title: 'Gjeldsordning tvungen antall', key: 'summary.debtRestructuringForcedCount' },
        { title: 'Intet til utlegg antall', key: 'summary.noAssetsForSeizureCount' },
        { title: 'Utleggstrekk antall', key: 'summary.assetSeizureCount' },
        { title: 'Utleggstrekk beløp', key: 'summary.assetSeizureAmount' },
      ],
    },
    {
    header: 'Pant',
    fields: [
        { title: 'Utleggspant antall', key: 'summary.assetSeizureCount' },
        { title: 'Utleggspant beløp', key: 'summary.assetSeizureAmount' },
        { title: 'Tvangsforretninger antall', key: 'summary.propertyForeclosureCount' },
        { title: 'Tvangsforretninger beløp', key: 'summary.propertyForeclosureAmount' },
        { title: 'Arrest antall', key: 'summary.arrestCount' },
        { title: 'Arrest beløp', key: 'summary.arrestAmount' },
    ],
    },
    {
    header: 'Eiendeler',
    fields: [
        { title: 'Eiendom antall', key: 'properties.length' },
        { title: 'Kjøretøy antall', key: 'vehicles.length' },
        { title: 'Enkeltpersonforetak', key: 'risk.summary.soleProprietor' },
        { title: 'Majoritetseier selskap', key: 'risk.summary.majorityOwnerCorporation'}
    ],
    },
  ];


  export const næringConfig2 = [
      {
        header: 'Grunndata',
        fields: [
              { title: 'Foretaksnavn', key: 'organisationName' },
              { title: 'Organisasjonsform', key: 'organisationForm' },
              { title: 'Stiftelsesdato', key: 'establishmentDate' },
              { title: 'Antall ansatte', key: 'numberOfEmployees' },
              { title: 'Status', key: 'status' },
              { title: 'Status dato', key: 'statusDate' },
              { title: 'Kredittsperre', key: 'creditFreeze' },
          ],
        },
      {
      header: 'Næringskode',
      fields: [
          { title: 'Næringskode', key: 'industries[0].naceCode' },
          { title: 'Næringskode tekst', key: 'industries[0].description' },
      ],
      },
      {
      header: 'Forretningsadresse',
      fields: [
          { title: 'Adresse', key: 'businessAddress.street' },
          { title: 'Poststed', key: 'businessAddress.postalArea' },
          { title: 'Postnummer', key: 'businessAddress.zipCode' },
          { title: 'Kommune', key: 'businessAddress.municipalityName' },
          { title: 'Kommunenummer', key: 'businessAddress.municipalityNumber' },
      ],
      },
      {
      header: 'Postadresse',
      fields: [
          { title: 'Adresse', key: 'postalAddress.street' },
          { title: 'Poststed', key: 'postalAddress.postalArea' },
          { title: 'Postnummer', key: 'postalAddress.zipCode' },
          { title: 'Kommune', key: 'postalAddress.municipalityName' },
          { title: 'Kommunenummer', key: 'postalAddress.municipalityNumber' },
      ],
      },
      {
      header: 'Kredittvurdering',
      fields: [
          { title: 'Kredittvurdering karakter', key: 'scoreRating' },
          { title: 'Kredittvurdering score', key: 'normalisedScore' },
          { title: 'Kredittvurdering forklaring', key: 'scoreRatingExplanation' },
          { title: 'Råscore', key: 'rawScore' },
          { title: 'Sannsynlighet for mislighold', key: 'probabilityOfDefault' },
          { title: 'Forslag til kredittgrensen(NOK)', key: 'creditLimit' },
          { title: 'Betalingsanmerkninger antall', key: 'summary.paymentRemarksCount' },
          { title: 'Betalingsanmerkninger beløp', key: 'summary.paymentRemarksAmount' },
          { title: 'Intet til utlegg antall', key: 'summary.noAssetsForSeizureCount' },
        ],
      },
      {
      header: 'Pant',
      fields: [
          { title: 'Utleggspant antall', key: 'summary.assetSeizureCount' },
          { title: 'Utleggspant beløp', key: 'summary.assetSeizureAmount' },
          { title: 'Tvangsforretninger antall', key: 'summary.propertyForeclosureCount' },
          { title: 'Tvangsforretninger beløp', key: 'summary.propertyForeclosureAmount' },
          { title: 'Arrest antall', key: 'summary.arrestCount' },
          { title: 'Arrest beløp', key: 'summary.arrestAmount' },
      ],
      },
      {
      header: 'Eiendeler',
      fields: [
          { title: 'Eiendom antall', key: 'properties.length' },
          { title: 'Kjøretøy antall', key: 'vehicles.length' },
      ],
      },
  ];
